import React from 'react';

import { Link } from 'react-router-dom';
import reportNotFoundImage from 'styles/assets/png/reportNotFound.png';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import classes from 'components/common/ErrorPages/ErrorPages.module.scss';

export const ReportNotFound = () => {
    return (
        <div className={classes.message}>
            <img src={reportNotFoundImage} className={classes.notFoundImage} alt={'Report not found'} />
            <div className={classes.description}>
                <h1>This report is no longer available</h1>
                <h2>The report you followed has been deleted or is no longer accessible.</h2>
            </div>
            <div>
                <Link to={AppRoutes.buildPath(AppRoutes.DASHBOARD_REPORTING_PATH)}>Go to Reports</Link> or{' '}
                <Link to={'/'}>Go to homepage</Link>
            </div>
        </div>
    );
};
